import donateStart from "./donateStart.js"

window.donateStart = donateStart;